import * as React from 'react';
import styled from '../styled-components';
import { mapMedia } from '../media';
import { StyledChildren } from '../StyledChildren';
var VisibilityImpl =
/*#__PURE__*/
styled(StyledChildren).withConfig({
  displayName: "Visibility__VisibilityImpl",
  componentId: "sc-1kf90k0-0"
})(["", ";"], mapMedia(function (prop, grid, props) {
  var hidden = prop('hidden');

  if (typeof hidden === 'undefined') {
    return [];
  } else if (hidden === true) {
    return [{
      display: 'none'
    }];
  } else {
    var _display = prop('display') || props.display || 'block';

    return [{
      display: _display
    }];
  }
}));

var Visibility = function Visibility(props) {
  return React.createElement(VisibilityImpl, props);
};

Visibility.defaultProps = {
  display: 'block'
};
export default Visibility;